import type { IMarketingSessionAddRequest } from '~/interfaces/dto/marketing/request';
import { useStorageService } from '~/composables/services/useStorageService';
import { useMarketingService } from '~/composables/services/useMarketingService';
import { globalKeys } from 'assets/data/global-keys';
import type { IInfoResponse } from '~/interfaces/dto/marketing/response';

export const useAddMarketingSession = async () => {
  const $storageService = useStorageService();
  const $marketingService = useMarketingService();

  const { deviceInfo, IpAddress, countryCode, hash } =
    $storageService.getSessionStorage<IInfoResponse>({
      key: globalKeys.siteConfigKeys.deviceInfo,
    });

  const marketingSession = $storageService.getSessionStorage({
    key: globalKeys.marketingKeys.marketingSession,
  });

  if (!marketingSession) {
    const sessionData: IMarketingSessionAddRequest = {
      bannerTag: $storageService.getCookie({
        key: globalKeys.marketingKeys.bannerTag,
      }),
      queryParamString: $storageService.getCookie({
        key: globalKeys.marketingKeys.originalQueryString,
      }),
      ipAddress: IpAddress,
      countryCode,
      userAgent: navigator.userAgent,
      sessionTrackingToken: hash,
      sessionMetaData: [
        {
          cookieName: globalKeys.marketingKeys.referrerBannerTag,
          cookieValue: $storageService.getCookie({
            key: globalKeys.marketingKeys.referrerBannerTag,
          }),
          cookieDomain: '',
        },
        {
          cookieName: globalKeys.marketingKeys.masterToken,
          cookieValue: $storageService.getCookie({
            key: globalKeys.marketingKeys.masterToken,
          }),
          cookieDomain: '',
        },
        {
          cookieName: globalKeys.marketingKeys.sessionToken,
          cookieValue: $storageService.getCookie({
            key: globalKeys.marketingKeys.sessionToken,
          }),
          cookieDomain: '',
        },
      ],
      ...deviceInfo,
    };

    await $marketingService.setMarketingSession(sessionData);
  }
};
